// store/customer/selectors/CustomerGlobalSelectors.ts
import { getShippingFFLObj } from 'helpers/DataHelper';

import type { RootState } from 'store';

export const headerFooterDataSelector = (state: RootState) =>
  state.customer.customerGlobal.headerFooterData;

export const loadingHeaderFooterSelector = (state: RootState) =>
  state.customer.customerGlobal.loadingHeaderFooterData;

export const liveUpdatesSelector = (state: RootState) =>
  state.customer.customerGlobal.live_updates ?? [];

export const megaMenuCategoriesSelector = (state: RootState) =>
  state.customer.customerGlobal.categories ?? [];
export const totalGunForSaleSelector = (state: RootState) =>
  state.customer.customerGlobal.total_gun_for_sale ?? 0;
export const totalFollowingFFLSelector = (state: RootState) =>
  state.customer.customerGlobal.total_followed_ffl ?? 0;
export const totalUnreadNotificationSelector = (state: RootState) =>
  state.customer.customerGlobal.unread_notification_count ?? 0;
export const socialMediaUrlsSelector = (state: RootState) =>
  state.customer.customerGlobal.socialMediaUrls ?? {};
export const supportEmailSelector = (state: RootState) =>
  state.customer.customerGlobal.support_email ?? '';
export const paymentTypesSelector = (state: RootState) =>
  state.customer.customerGlobal.payment_types ?? [];
export const selectedDeliveryAddressSelector = (state: RootState) =>
  state.customer.customerGlobal.selectedDeliveryAddress ?? null;
export const deliveryLocationModalOpenSelector = (state: RootState) =>
  state.customer.customerGlobal.deliveryLocationModalOpen ?? false;
export const guestDeliveryFFLModalOpenSelector = (state: RootState) =>
  state.customer.customerGlobal.guestDeliveryFFLModalOpen ?? false;
export const mobileMenuOpenSelector = (state: RootState) =>
  state.customer.customerGlobal.mobileMenuOpen ?? false;
// name of the FFL attached to the address picked in the header "Deliver to" block
export const selectedDeliveryFFLNameSelector = (state: RootState) => {
  const selectedFfl = selectedDeliveryAddressSelector(state)?.selected_ffl;
  if (!selectedFfl) return '';
  const fflObj = getShippingFFLObj(selectedFfl);
  return fflObj?.label || fflObj?.business_name || '';
};

// whether the FFL attached to the "Deliver to" address is a claimed/registered business
// profile (nested under .ffl) rather than a bare unclaimed ATF license record - the
// verified-tick badge next to the FFL name should only show for the former.
export const selectedDeliveryFFLIsRegisteredSelector = (state: RootState) => {
  const selectedFfl = selectedDeliveryAddressSelector(state)?.selected_ffl;
  if (!selectedFfl) return false;
  const fflObj = getShippingFFLObj(selectedFfl);
  return !!fflObj?.ffl;
};

export const appThemeSelector = (state: RootState) =>
  state.customer.customerGlobal.appTheme ?? 'dark';
